import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ApkState } from '@store/reducers';

export const selectApkState = createFeatureSelector<ApkState>('apk');

export const selectApkLoading = createSelector(
  selectApkState,
  (state) => state.loading
);

export const selectApkList = createSelector(
  selectApkState,
  (state) => state.apkList
);

export const selectApkError = createSelector(
  selectApkState,
  (state) => state.error
);

export const selectApkEditMode = createSelector(
  selectApkState,
  (state) => state.editMode
);

export const selectApkIsEditing = createSelector(
  selectApkState,
  (state) => state.isEditing
);

export const selectApkForm = createSelector(
  selectApkState,
  (state) => state.apkForm
);

export const selectApkId = createSelector(
  selectApkState,
  (state) => state.apkId
);

export const selectApk = createSelector(
  selectApkState,
  (state) => state.apk
);
